import { render, staticRenderFns } from "./rincian.vue?vue&type=template&id=33974a8b&"
import script from "./rincian.vue?vue&type=script&lang=js&"
export * from "./rincian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports